export default {"src":"/_next/static/image/public/images/down_arrow.cf9ee346679a98803155639afadfb557.svg","height":9,"width":16};